import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './style.css';

// Initialize MSAL before rendering
import { msalInstance } from './auth/authConfig';

// Ensure MSAL is initialized
msalInstance.initialize().then(() => {
  // Check if there are already accounts in the cache
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length > 0) {
    // Set the first account as active
    msalInstance.setActiveAccount(accounts[0]);
  }

  // Render the app
  ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
